// src/App.tsx ou src/index.tsx
import { useEffect } from 'react';

const useClarity = () => {
  useEffect(() => {
    if (window && (window as any).clarity) return; // evita múltiplas injeções

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", ${process.env.REACT_APP_BASE_BACK});
    `;
    document.head.appendChild(script);
  }, []);
};

export default useClarity;

declare global {
  interface Window {
    clarity: (...args: any[]) => void;
  }
}

export function mascararEmail(email: string) {
  const [usuario, dominio] = email.split('@');
  const prefixo = usuario.slice(0, 2) + '***';
  return `${prefixo}@${dominio}`;
}